/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InsuranceProviderViewModel } from './InsuranceProviderViewModel'; 

export function getInsuranceProviderOptions(id: string, onSuccess?: (result: InsuranceProviderViewModel) => void) {
	return queryOptions({
		queryKey: ['insurance-provider', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/insuranceproviders/queries/getinsuranceprovider/' + id;
			const resp = await axios.get<InsuranceProviderViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}